import Dropzone from "react-dropzone-uploader";

/**
 * Dosya yükleme alanlarının varsayılan metinleri.
 *
 * Kütüphanenin varsayılanı İngilizce ("Drag Files or Click to Browse",
 * "Add Files", "Submit") ve panelde 20'den fazla yükleme alanı bu metinle
 * görünüyordu. Ekranlar kendi metnini verirse o kullanılır.
 */
Object.assign(Dropzone.defaultProps, {
  inputContent: "Dosyayı sürükleyin veya seçmek için tıklayın",
  inputWithFilesContent: "Dosya ekle",
  submitButtonContent: "Gönder",
});
